import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";

/** Fixed button that appears after scrolling and returns the reader to the top. */
export function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 600);
    }

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="العودة إلى الأعلى"
      className={`blank-scrolltop ${visible ? "is-visible" : ""}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <ArrowUp className="h-[18px] w-[18px]" aria-hidden="true" />
    </button>
  );
}
